"use client";
import Script from "next/script";

export default function Footer () {
    const handleScriptError = (event) => {
        console.error('Une erreur est survenue lors du chargement du script :', event.error);
        // Vous pouvez ajouter du code pour gérer l'erreur ici, par exemple : 
        // Envoyer un rapport d'erreur à un service de suivi des erreurs
        // Afficher un message d'erreur à l'utilisateur
      };

    return (<>
    <footer className="bg-charcoal-blue pb-4 sm-pb-50px" style={{backgroundImage: "url(images/demo-branding-agency-pattern.svg)"}}>
            <div className="container">
                <div className="row mb-6">
                    <div className="col-lg-5 col-md-6 sm-mb-30px order-2 order-md-1">
                        <h3 className="text-white fw-500 alt-font mb-50px ls-minus-1px sm-mb-30px">Ready to elevate<br/> your brand?</h3>
                        <div>
                        <a href="/pricing" className="btn btn-extra-large  fw-400" style={{backgroundImage: "url(/images/bg-btn-2.png)", backgroundSize: "100% 100%",color: "#ffffff", backgroundRepeat: "no-repeat"}}>AI copywriting - Start now</a>
                        </div>
                        {false && <div className="mt-8">
                            <a href="/home" className="footer-logo">
                            <svg className="default-logo"  xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="143.507" height="59.343" viewBox="0 0 143.507 59.343">
                                        <defs>
                                            <clipPath id="clip-path">
                                            <path id="Union_1"  data-name="Union 1" d="M7.493,46.277a9.7,9.7,0,0,1-1.309-.413l-.227-.072.034-.007A9.781,9.781,0,0,1,0,36.767V9.778A9.778,9.778,0,0,1,9.778,0H36.767a9.778,9.778,0,0,1,9.778,9.778V36.767q0,.277-.015.551l.015,0V58.6Z" transform="translate(0 0)"/>
                                            </clipPath>
                                            <pattern id="pattern" width="1" height="1" patternTransform="matrix(1, 0, 0, -1, 0, 185.447)" viewBox="-41.036 0 142.631 92.723">
                                            <image id="image" width="142.631" height="92.723" href="/images/demo-branding-agency-pattern.svg"/>
                                            </pattern>
                                            <clipPath id="clip-path-2">
                                            <path id="Rectangle_13" data-name="Rectangle 13" d="M0,0H21.513V9.778H0Z" fill="none" stroke="#9d3de4" strokeWidth="1"/>
                                            </clipPath>
                                        </defs>
                                        <g id="Group_4" data-name="Group 4" transform="translate(651 524.379)">
                                            <text id="Xylo" transform="translate(-580.493 -488.379)" fill="#8f37e6" fontSize="37" fontFamily="SpaceGrotesk-SemiBold, Space Grotesk Variable" font-weight="600" letterSpacing="-0.055em"><tspan x="0" y="0">Xylo</tspan></text>
                                            <g id="Component_1_1" data-name="Component 1 – 1" transform="translate(-651 -523.639)">
                                            <g id="Mask_Group_7" data-name="Mask Group 7" transform="translate(0 0)" clipPath="url(#clip-path)">
                                                <rect id="Screenshot_2024-02-01_at_17.14.53" data-name="Screenshot 2024-02-01 at 17.14.53" width="142.631" height="92.723" transform="translate(-96.086 -15.373)" fill="url(#pattern)"/>
                                            </g>
                                            <path id="Rectangle_11" data-name="Rectangle 11" d="M4.3,0H24.25a4.3,4.3,0,0,1,4.3,4.3V24.25a4.3,4.3,0,0,1-4.3,4.3H4.3A4.3,4.3,0,0,1,0,24.25V4.3A4.3,4.3,0,0,1,4.3,0Z" transform="translate(8.996 8.996)" fill="#fff"/>
                                            <g id="Mask_Group_8" data-name="Mask Group 8" transform="translate(12.125 23.468)" clipPath="url(#clip-path-2)">
                                                <g id="Ellipse_6" data-name="Ellipse 6" transform="translate(1.565 -9.778)" fill="none">
                                                <path d="M9.387,0A9.387,9.387,0,1,1,0,9.387,9.387,9.387,0,0,1,9.387,0Z" stroke="none"/>
                                                <path d="M 9.387282371520996 -5.7220458984375e-06 C 14.57173252105713 -5.7220458984375e-06 18.77457046508789 4.202832221984863 18.77457046508789 9.387282371520996 C 18.77457046508789 14.57173252105713 14.57173252105713 18.77457046508789 9.387282371520996 18.77457046508789 C 4.202832221984863 18.77457046508789 -5.7220458984375e-06 14.57173252105713 -5.7220458984375e-06 9.387282371520996 C -5.7220458984375e-06 4.202832221984863 4.202832221984863 -5.7220458984375e-06 9.387282371520996 -5.7220458984375e-06 Z" stroke="none" fill="#9d3de4"/>
                                                </g>
                                            </g>
                                            </g>
                                        </g>
                                    </svg>
                            </a>
                        </div>}
                    </div>
                    
                    <div className="col-md-3 col-6 order-2 order-md-2">
                        <span className="alt-font fs-14 text-uppercase mb-5px d-block text-white ls-1px">Company</span>
                        <ul>
                            <li><a href="/home">Home</a></li>
                            <li><a href="/agency">Agency</a></li>
                            <li><a href="/services">Services</a></li>
                            <li><a href="/pricing">Pricing</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="col-md-3 col-6 order-3 order-md-3">
                        <span className="alt-font fs-14 text-uppercase mb-5px d-block text-white ls-1px">Legal</span>
                        <ul>
                            <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
                            <li><a href="/privacy">Privacy</a></li>
                            <li><a href="/refunds">Refunds</a></li>
                        </ul>
                        <div className="mt-8" style={{background: "#FFFFFF", width: "max-content", padding: "4px"}}>
                            <img src="/images/checkout/card-visa-color.png" alt="Visa" style={{height: "24px"}} />
                            <img src="/images/checkout/card-mastercard-color.png" alt="Mastercard" style={{height: "24px", marginLeft: "12px"}} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-center last-paragraph-no-margin">
                        <p className="fs-13 lh-22">
                            <b>LUXELOOM LIMITED, Registered No. HE 459401</b><br/>
                            Karpasias 30D, 2046 Nicosia, Cyprus<br/>
                            &copy; 2024 Xylo
                        </p>
                    </div>
                </div>
            </div>
        </footer>
        <div className="scroll-progress d-none d-xxl-block">
          <a href="#" className="scroll-top" aria-label="scroll">
            <span className="scroll-text">Scroll</span><span className="scroll-line"><span className="scroll-point"></span></span>
          </a>
        </div>
        
        {/* <Script strategy="beforeInteractive" src="/assets/js/jquery.js"></Script> */}
        <Script  src="/assets/js/vendors.js" onError={handleScriptError}></Script>
        {/* <Script  src="/assets/js/main.js" onError={handleScriptError}></Script> */}
    </>)
}